module.exports = __webpack_public_path__ + "static/media/sub.bdc3b754.svg";